import { Loader2 } from "lucide-react"

import { cn } from "@/lib/utils"

export function LoadingState({ label, className }: { label?: string; className?: string }) {
  return (
    <div
      className={cn(
        "flex items-center justify-center gap-2 py-20 text-palette-jungleGreen500",
        className,
      )}
    >
      <Loader2 className="h-5 w-5 animate-spin text-palette-jungleGreen400" />
      {label && <span>{label}</span>}
    </div>
  )
}
